// Mini trendový graf pre finančnú metriku naprieč rokmi — mark spec prevzatý z
// docs/design/profil-firmy-mockup.html (.spark-line/.spark-area/.spark-dot). Jedna
// séria, žiadna legenda netreba (názov metriky je nadpis nad grafom).
const WIDTH = 560;
const HEIGHT = 64;
const TOP_PAD = 10;
const BOTTOM_PAD = 20;

interface Props {
  // Chronologicky (najstarší → najnovší), null hodnoty sa preskočia.
  values: (number | null)[];
}

export function Sparkline({ values }: Props) {
  const points = values
    .map((v, i) => (v == null ? null : { x: i, y: v }))
    .filter((p): p is { x: number; y: number } => p !== null);

  if (points.length < 2) return null;

  const min = Math.min(...points.map((p) => p.y));
  const max = Math.max(...points.map((p) => p.y));
  const range = max - min || 1;
  const n = values.length;

  const scaled = points.map((p) => ({
    x: (p.x / (n - 1)) * WIDTH,
    y: HEIGHT - BOTTOM_PAD - ((p.y - min) / range) * (HEIGHT - TOP_PAD - BOTTOM_PAD),
  }));

  const linePath = scaled
    .map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x.toFixed(1)},${p.y.toFixed(1)}`)
    .join(' ');
  const areaPath = `${linePath} L${scaled[scaled.length - 1]!.x.toFixed(1)},${HEIGHT} L${scaled[0]!.x.toFixed(1)},${HEIGHT} Z`;
  const last = scaled[scaled.length - 1]!;

  return (
    <svg
      className="spark"
      width="100%"
      height={HEIGHT}
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      preserveAspectRatio="none"
    >
      <line className="spark-grid" x1={0} y1={16} x2={WIDTH} y2={16} />
      <line className="spark-grid" x1={0} y1={48} x2={WIDTH} y2={48} />
      <path className="spark-area" d={areaPath} />
      <path className="spark-line" d={linePath} />
      <circle className="spark-dot" cx={last.x} cy={last.y} r={3.5} />
    </svg>
  );
}
